"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "watch", {
    enumerable: true,
    get: function() {
        return watch;
    }
});
const _chokidar = /*#__PURE__*/ _interop_require_default(require("chokidar"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _workspacetools = require("workspace-tools");
const _events = /*#__PURE__*/ _interop_require_default(require("events"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function watch(cwd, packageInfos) {
    const events = new _events.default();
    const root = (0, _workspacetools.getWorkspaceRoot)(cwd);
    // generate a tree index of all the packages
    const packageIndex = createPackageIndex(root, packageInfos);
    const packagePaths = Object.values(packageInfos).map((pkg)=>_path.default.dirname(pkg.packageJsonPath));
    // watch for changes in the packages
    const watcher = _chokidar.default.watch(packagePaths, {
        cwd: root,
        ignored: [
            "**/node_modules/**",
            "**/dist/**",
            "**/build/**",
            "**/lib/**"
        ]
    });
    let timeoutHandle;
    // when a change happens, find the package that changed
    watcher.on("change", (filePath)=>{
        if (timeoutHandle) {
            clearTimeout(timeoutHandle);
        }
        timeoutHandle = setTimeout(()=>{
            const packageName = findPackageByPath(filePath, packageIndex);
            events.emit("change", packageName);
        }, 200);
    });
    return events;
}
function createPackageIndex(root, packageInfos) {
    const pathIndex = {};
    // generate a tree index of all the packages
    for (const [packageName, info] of Object.entries(packageInfos)){
        const packagePath = _path.default.relative(root, _path.default.dirname(info.packageJsonPath));
        const pathParts = packagePath.split(/[/\\]/);
        let pointer = pathIndex;
        for (const pathPart of pathParts){
            if (!pointer[pathPart]) {
                pointer[pathPart] = {};
            }
            pointer = pointer[pathPart];
        }
        pointer.packageName = packageName;
    }
    return pathIndex;
}
function findPackageByPath(filePath, index) {
    const pathParts = filePath.split(/[/\\]/);
    let pointer = index;
    for (const pathPart of pathParts){
        if (!pointer[pathPart]) {
            // eslint-disable-next-line no-console
            console.log(pathPart, filePath);
            break;
        }
        if (pointer[pathPart].packageName) {
            return pointer[pathPart].packageName;
        }
        pointer = pointer[pathPart];
    }
    return undefined;
}
